import * as PIXI from "pixi.js"

export default class BaseSymbol extends PIXI.Container {

  constructor(data) {
    super()
    this.init(data)
  }

  init(data) {
  }


}
